export default {
  async getStatementBreakDown(userId, config = {}) {
    return await this.$get({
      url: `${this.$baseurl}/admin/statements/${userId}/breakdown`,
      headers: this.headers,
      ...config,
    });
  },
};
